// Stub for @fortawesome/pro-light-svg-icons
// Provides empty fal export to prevent errors
export const fal = {
  prefix: 'fal',
  iconName: 'stub',
  icon: [0, 0, [], '', '']
};
